import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import BorrowingStatus from '../../shared/BorrowingStatus';
import SidebarCompactTitle from '../../sidebar/SidebarCompactTitle';

export default class AccountMessagesStatus extends BcReactComponent {
  render() {
    const { currentSection } = this.props;

    return (
      <BorrowingStatus currentSection={currentSection} to="/v2/accountmessages">
        <SidebarCompactTitle
          title={<FormattedMessage id="section_title_messages" />}
          count={<span>{this.props.messages.size}</span>}
          selected={currentSection} />
      </BorrowingStatus>
    );
  }
}

AccountMessagesStatus.propTypes = {
  currentSection: PropTypes.bool,
  messages: ImmutablePropTypes.map.isRequired
};



// WEBPACK FOOTER //
// ./app/components/borrowing/accountmessages/AccountMessagesStatus/AccountMessagesStatus.jsx